import { vuexFileBase } from '@/store/compositionV2/utils/file'

const createActions = () => ({
  ...vuexFileBase.createActions(),

  async createItemAndPostFiles ({ dispatch, state }, data) {
    const response = await state.api.create(data)
    const id = response.data.data.id

    await dispatch('checkAndPostNewFiles', { id, data, addExpand: false })

    return response
  },

  async updateItemAndProcessFiles ({ state, dispatch }, { id, data }) {
    const response = await state.api.update(id, data)

    await dispatch('checkAndDeleteFiles', id)
    await dispatch('processPostAndSortFiles', { id, data })

    return response
  }
})

export const vuexSaveItemAndFiles = {
  createActions
}
